// Constants
import { INITIALIZE_UNIVERSITY_DETAILS } from "../actions/universityDetailsActions";
const initialState = { loading: true, data: {} };

const universityDetailsReducer = (state = initialState, action) => {
    if (action.type === INITIALIZE_UNIVERSITY_DETAILS) {
        return {
            data: action.payload,
            loading: false,
        };
    } else {
        return state;
    }
};

export default universityDetailsReducer;
